import { gql } from '@apollo/client';

export const mutation = gql`
  mutation RemoveTagFromPipeline($pipelineId: uuid!, $tagId: uuid!) {
    delete_pipeline_tags(where: { pipelineId: { _eq: $pipelineId }, tagId: { _eq: $tagId } }) {
      affected_rows
    }
  }
`;

export function buildVariables({ pipelineId, tagId }) {
  return { pipelineId, tagId };
}
